// extracted by mini-css-extract-plugin
export default {"mainBlock":"Footer_mainBlock__XW+Xj","linksGrid":"Footer_linksGrid__V+tQd","hoverText":"Footer_hoverText__NSNBB","footerInner":"Footer_footerInner__00TSv"};